// extracted by mini-css-extract-plugin
module.exports = {"ldsHeart":"HeartSpin_ldsHeart__11ubk"};